import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesStatusesTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-statuses-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=status'],
};
